import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const Collection = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M18,12.6 L18,1.8 C18,0.81 17.19,0 16.2,0 L5.4,0 C4.41,0 3.6,0.81 3.6,1.8 L3.6,12.6 C3.6,13.59 4.41,14.4 5.4,14.4 L16.2,14.4 C17.19,14.4 18,13.59 18,12.6 Z M0,3.6 L0,16.2 C0,17.19 0.81,18 1.8,18 L14.4,18 L14.4,16.2 L2.8,16.2 C2.24771525,16.2 1.8,15.7522847 1.8,15.2 L1.8,3.6 L1.8,3.6 L0,3.6 Z" })));
};
export default Collection;
